<template>
    <div class="observer"/>
</template>
<script>
export default {
    props: ['options'],
    data: () => ({
        observer: null,
    }),
    mounted() {
        const options = this.options || {};
        this.observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
                const element = entry.target.offsetParent;
                const scrollTop = entry.target.offsetParent.scrollTop;
                this.$emit("intersect", element, scrollTop);
            }
        }, options);

        this.observer.observe(this.$el);
    },
    destroyed() {
        this.observer.disconnect();
    },
};
</script>
